import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "col-md-6 mx-auto" }
const _hoisted_2 = { class: "dl-horizontal" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("dt", null, "ID", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("dt", null, "Name", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("dt", null, "Match", -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("dt", null, "Max rejection", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("dt", null, "Price", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("dt", null, "Jackpot init (chip)", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("dt", null, "Jackpot win percent", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("dt", null, "Jackpot donation (chip)", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("dt", null, "Prizes", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("dt", null, "Type", -1)
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("dt", null, "Status", -1)
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("dt", null, "Time unit", -1)
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("dt", null, "Time duration", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("dt", null, "Publish seconds", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("dt", null, "Start seconds", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("dt", null, "Close seconds", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("dt", null, "End seconds", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("dt", null, "Publish time", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("dt", null, "Unpublish time", -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h6", null, "Preview of next cycle schedule:", -1)
const _hoisted_28 = { class: "card-footer bg-white border border-light" }
const _hoisted_29 = {
  key: 0,
  class: "col text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_simple_table = _resolveComponent("app-simple-table")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_card = _resolveComponent("app-card")!

  return (_openBlock(), _createBlock(_component_app_card, {
    class: "col-lg-10 mx-auto",
    label: "Arena Detail"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("dl", _hoisted_2, [
          _createElementVNode("tr", null, [
            _hoisted_3,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.id), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_4,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.name), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_5,
            (_ctx.model.matchId)
              ? (_openBlock(), _createElementBlock("dd", _hoisted_6, [
                  _createVNode(_component_router_link, {
                    to: { name: _ctx.ROUTE_NAME_GAME.MATCH.DETAIL, params: { id: _ctx.model.matchId } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.model.matchName), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_7,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.maxRejection), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_8,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.price), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_9,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.jackpotInit), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_10,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.jackpotWinPercent), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_11,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.jackpotDonation), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_12,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.prizes), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_13,
            _createElementVNode("dd", {
              innerHTML: _ctx.renderOption(_ctx.ArenaTicketTypeList, _ctx.model.ticketType)
            }, null, 8, _hoisted_14)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_15,
            _createElementVNode("dd", {
              innerHTML: _ctx.renderOption(_ctx.ArenaStatusList, _ctx.model.status)
            }, null, 8, _hoisted_16)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_17,
            _createElementVNode("dd", {
              innerHTML: _ctx.renderTimeUnit(_ctx.model.timeUnit)
            }, null, 8, _hoisted_18)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_19,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.timeDuration), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_20,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.publishSeconds), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_21,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.startSeconds), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_22,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.closeSeconds), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_23,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.endSeconds), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_24,
            _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.model.publishTime)), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_25,
            _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.model.unpublishTime)), 1)
          ])
        ])
      ]),
      (_ctx.model.nextCycle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _hoisted_27,
            _createVNode(_component_app_simple_table, {
              items: [_ctx.model.nextCycle],
              fields: ['publishTime', 'startTime', 'closeTime', 'endTime', 'unpublishTime', 'archiveTime']
            }, null, 8, ["items"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_28, [
        (_ctx.model.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              (_ctx.model.canEdit)
                ? (_openBlock(), _createBlock(_component_app_button, {
                    key: 0,
                    name: "Edit",
                    icon: "fa-edit",
                    theme: "info",
                    to: { name: _ctx.ROUTE_NAME_ARENA.ITEM.EDIT, params: { id: _ctx.model.id } }
                  }, null, 8, ["to"]))
                : _createCommentVNode("", true),
              _createVNode(_component_app_button, {
                name: "Clone",
                icon: "fa-copy",
                theme: "info",
                to: { name: _ctx.ROUTE_NAME_ARENA.ITEM.CLONE, params: { id: _ctx.model.id } }
              }, null, 8, ["to"]),
              _createVNode(_component_app_button, {
                name: "Medal",
                icon: "fa-medal",
                theme: "info",
                to: { name: _ctx.ROUTE_NAME_ARENA.ITEM.MEDAL, params: { id: _ctx.model.id } }
              }, null, 8, ["to"]),
              (_ctx.model.canEnable)
                ? (_openBlock(), _createBlock(_component_app_button, {
                    key: 1,
                    name: "Enable",
                    icon: "fa-play",
                    theme: "success",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.actions.enable(_ctx.model.id)), ["prevent"]))
                  }))
                : _createCommentVNode("", true),
              (_ctx.model.canDisable)
                ? (_openBlock(), _createBlock(_component_app_button, {
                    key: 2,
                    name: "Disable",
                    icon: "fa-stop",
                    theme: "warning",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.actions.disable(_ctx.model.id)), ["prevent"]))
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}